// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DictionaryLanguageDto } from '../models';
// @ts-ignore
import type { EmployeesSearchRequestDto } from '../models';
// @ts-ignore
import type { EmployeesSearchResponseDto } from '../models';
// @ts-ignore
import type { EmployeesSortValueDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * EmployeesSearchRestApi - axios parameter creator
 */
export const EmployeesSearchRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {EmployeesSortValueDto} employeesSort 
         * @param {DictionaryLanguageDto} language 
         * @param {EmployeesSearchRequestDto} employeesSearchRequestDto Find company employees request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEmployees: async (page: number, pageSize: number, sortDirection: SortDirectionDto, employeesSort: EmployeesSortValueDto, language: DictionaryLanguageDto, employeesSearchRequestDto: EmployeesSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchEmployees', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchEmployees', 'pageSize', pageSize)
            // verify required parameter 'sortDirection' is not null or undefined
            assertParamExists('searchEmployees', 'sortDirection', sortDirection)
            // verify required parameter 'employeesSort' is not null or undefined
            assertParamExists('searchEmployees', 'employeesSort', employeesSort)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('searchEmployees', 'language', language)
            // verify required parameter 'employeesSearchRequestDto' is not null or undefined
            assertParamExists('searchEmployees', 'employeesSearchRequestDto', employeesSearchRequestDto)
            const localVarPath = `/api/v1/employees/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (employeesSort !== undefined) {
                localVarQueryParameter['employeesSort'] = employeesSort;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeesSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeesSearchRestApi - functional programming interface
 */
export const EmployeesSearchRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeesSearchRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {EmployeesSortValueDto} employeesSort 
         * @param {DictionaryLanguageDto} language 
         * @param {EmployeesSearchRequestDto} employeesSearchRequestDto Find company employees request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEmployees(page: number, pageSize: number, sortDirection: SortDirectionDto, employeesSort: EmployeesSortValueDto, language: DictionaryLanguageDto, employeesSearchRequestDto: EmployeesSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeesSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEmployees(page, pageSize, sortDirection, employeesSort, language, employeesSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesSearchRestApi.searchEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeesSearchRestApi - factory interface
 */
export const EmployeesSearchRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeesSearchRestApiFp(configuration)
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {EmployeesSortValueDto} employeesSort 
         * @param {DictionaryLanguageDto} language 
         * @param {EmployeesSearchRequestDto} employeesSearchRequestDto Find company employees request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEmployees(page: number, pageSize: number, sortDirection: SortDirectionDto, employeesSort: EmployeesSortValueDto, language: DictionaryLanguageDto, employeesSearchRequestDto: EmployeesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeesSearchResponseDto> {
            return localVarFp.searchEmployees(page, pageSize, sortDirection, employeesSort, language, employeesSearchRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeesSearchRestApi - interface
 */
export interface EmployeesSearchRestApiInterface {
    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SortDirectionDto} sortDirection 
     * @param {EmployeesSortValueDto} employeesSort 
     * @param {DictionaryLanguageDto} language 
     * @param {EmployeesSearchRequestDto} employeesSearchRequestDto Find company employees request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchEmployees(page: number, pageSize: number, sortDirection: SortDirectionDto, employeesSort: EmployeesSortValueDto, language: DictionaryLanguageDto, employeesSearchRequestDto: EmployeesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeesSearchResponseDto>;

}

/**
 * EmployeesSearchRestApi - object-oriented interface
 */
export class EmployeesSearchRestApi extends BaseAPI implements EmployeesSearchRestApiInterface {
    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SortDirectionDto} sortDirection 
     * @param {EmployeesSortValueDto} employeesSort 
     * @param {DictionaryLanguageDto} language 
     * @param {EmployeesSearchRequestDto} employeesSearchRequestDto Find company employees request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchEmployees(page: number, pageSize: number, sortDirection: SortDirectionDto, employeesSort: EmployeesSortValueDto, language: DictionaryLanguageDto, employeesSearchRequestDto: EmployeesSearchRequestDto, options?: RawAxiosRequestConfig) {
        return EmployeesSearchRestApiFp(this.configuration).searchEmployees(page, pageSize, sortDirection, employeesSort, language, employeesSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

